import AddIcon from '@mui/icons-material/Add'
import {useEffect, useState, useMemo, useCallback} from 'react'
import {Container, Body, Header} from './Recommendations.style'
import TitleDescriptionInput from '../../../components/customInput/TitleDescriptionInput'
import {useLocation} from 'react-router-dom'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {initCurrent, updateCurrent} from '../../../redux/slice/currentItem'
import _ from 'underscore'
import IdRecommendationsTable, {
    LinkedInterpretations
} from '../../../components/tables/[id]/recommendations/IdRecommendations'
import {Modal, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material'
import ConnectToInterpretationTable from '../../../components/tables/connectTo/interpretations/interpretation'
import {ConnectModal} from '../../../components/customStyledElements'
import MyModal from '../../../components/myModal/myModal'
import InterpretationMainTable from "../../../components/tables/main/interpretation/InterpretationTable";
import Dropzone from '../../../components/myDropzone/myDropzone'
import {FilterHead} from '../../biomarkers/[id]/components/FiltersComponent.styles'
import {FilterContainer, LeftSide, NavElement} from '../../subjects/Subject.style'
import MyDropdown from '../../../components/MyDropdown/MyDropdown'

const Recommendations = () => {
    const dispatch = useAppDispatch()
    const {pathname} = useLocation()
    const {interpretations, recommendations} = useAppSelector(
        (state) => state.data
    )

    console.log("qqqqq interpretations", interpretations);

    const {currentItem} = useAppSelector((state) => {
        return state
    })

    const [isConnectOpen, setIsConnectOpen] = useState(false)
    const [language, setLanguage] = useState<string>('en')
    const [isAddLanguageModalOpen, setIsAddLanguageModalOpen] = useState(false)
    const [selectedNewLanguage, setSelectedNewLanguage] = useState('')
    const [localDescription, setLocalDescription] = useState('')

    useEffect(() => {
        const desc = typeof currentItem?.data?.description === 'object'
            ? currentItem.data.description[language] || (language === 'en' ? currentItem.data.description['en'] || '' : '')
            : currentItem?.data?.description || ''
        setLocalDescription(desc)
    }, [currentItem?.data?.description, language])

    const getRecommendation = () => {
        const id = pathname.split('/').pop() || ''
        dispatch(initCurrent({data: recommendations[id], type: 'recommendation'}))
    }

    useEffect(() => getRecommendation(), [recommendations])

    const handleUpdateSubjects = async (item: any) => {
        console.log("update current4444444444", item)
        dispatch(updateCurrent(item))
    }

    const currentInterpretation = currentItem.data || {}

    const recommendation = (currentItem.data || {});

    const availableLanguages = useMemo(() => {
        const name = currentItem?.data?.name
        return name && typeof name === 'object' ? Object.keys(name) : ['en']
    }, [currentItem?.data?.name])

    const handleRemoveLanguage = useCallback((langToRemove: string) => {
        if (availableLanguages.length <= 1) {
            alert('Cannot remove the last language')
            return
        }
        
        if (langToRemove === 'en') {
            alert('Cannot remove English language')
            return
        }
        
        if (window.confirm(`Are you sure you want to remove language "${langToRemove.toUpperCase()}"?`)) {
            const updatedName = { ...currentItem?.data?.name }
            delete updatedName[langToRemove]
            
            const updatedDescription = { ...currentItem?.data?.description }
            delete updatedDescription[langToRemove]
            
            dispatch(updateCurrent({
                name: updatedName,
                description: updatedDescription
            }))
            
            if (language === langToRemove) {
                setLanguage('en')
            }
        }
    }, [availableLanguages.length, currentItem?.data?.name, currentItem?.data?.description, dispatch, language])

    const handleAddLanguage = useCallback(() => {
        const code = selectedNewLanguage.toLowerCase().trim()
        if (!code || code.length > 2 || availableLanguages.includes(code) || !currentItem?.data) return

        const newNameObj =
            typeof currentItem.data.name === 'object'
                ? { ...currentItem.data.name, [code]: '' }
                : { en: currentItem.data.name || '', [code]: '' }

        const newDescriptionObj =
            typeof currentItem.data.description === 'object'
                ? { ...currentItem.data.description, [code]: '' }
                : { en: currentItem.data.description || '', [code]: '' }

        dispatch(updateCurrent({ name: newNameObj, description: newDescriptionObj }))
        setLanguage(code)
        setIsAddLanguageModalOpen(false)
        setSelectedNewLanguage('')
    }, [dispatch, selectedNewLanguage, availableLanguages, currentItem])

    console.log("qqqqq currentInterpretation", currentInterpretation);
    let isEditor = (global as any)?.isEditor;

    return (
        <Container data-animch>
            {/* Language Switcher */}
            <LeftSide style={{ justifyContent: 'flex-start', marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                {availableLanguages.map((lang, index) => (
                    <div key={lang} style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginRight: index < availableLanguages.length - 1 ? 8 : 0 
                    }}>
                        <NavElement
                            as="span"
                            selected={language === lang}
                            onClick={() => setLanguage(lang)}
                            style={{ cursor: 'pointer', marginRight: 4 }}
                        >
                            {lang.toUpperCase()}
                        </NavElement>
                        {lang !== 'en' && availableLanguages.length > 1 && (
                            <span
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleRemoveLanguage(lang)
                                }}
                                style={{
                                    marginLeft: 4,
                                    cursor: 'pointer',
                                    color: '#ff4444',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}
                            >
                                ×
                            </span>
                        )}
                    </div>
                ))}
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setIsAddLanguageModalOpen(true)}
                    style={{ marginLeft: 8, fontSize: '12px', padding: '4px 8px' }}
                >
                    + Add Language
                </Button>
            </LeftSide>

            <TitleDescriptionInput
                callback={(data) => {
                    if (data.description !== undefined) {
                        setLocalDescription(data.description)
                    }
                    handleUpdateSubjects(data)
                }}
                name={typeof currentInterpretation?.name === 'object' 
                    ? currentInterpretation.name[language] || (language !== 'en' ? '' : currentInterpretation.name['en'] || '')
                    : currentInterpretation?.name || ''}
                description={localDescription}
                language={language}
                onLanguageChange={(lang, field, value) => {
                    const currentData = currentItem?.data || {}
                    const currentField = currentData[field] || {}
                    
                    if (field === 'description') {
                        setLocalDescription(value)
                    }
                    
                    const updatedField = typeof currentField === 'object' 
                        ? { ...currentField, [lang]: value }
                        : { en: currentField || '', [lang]: value }
                    
                    dispatch(updateCurrent({ [field]: updatedField }))
                }}
            />
            <Body>

                <div style={{display: 'flex'}}>
                    <MyDropdown title={'Recommendation step'}
                                items={[{name: '1'}, {name: '2'}, {name: '3'}, {name: '4'}]}
                                value={recommendation.sortingValue} onChange={(item: any) => {
                        console.log('up change on chagne', item)
                        handleUpdateSubjects({sortingValue: item})
                    }}></MyDropdown>
                    <MyDropdown title={'Recommendation sort'}
                                items={[{name: 'A'}, {name: 'B'}, {name: 'C'}, {name: 'D'}]}
                                value={recommendation.sortingType} onChange={(item: any) => {
                        console.log('up change on chagne', item)
                        handleUpdateSubjects({sortingType: item})
                    }}></MyDropdown>

                </div>
                <div style={{display: 'flex'}}>
                    <MyDropdown title={'Is One In Step'}></MyDropdown>
                    <input type={'checkbox'} style={{width: '15px'}} checked={Boolean(recommendation?.info?.isOneInList)}
                           onChange={v => {
                               handleUpdateSubjects({info: {...recommendation?.info || {}, isOneInList: !(recommendation?.info?.isOneInList)}})
                           }}></input>
                    {/*{recommendation?.info?.isOneInList ? 'yes': 'no'}*/}
                </div>
                <div>
                    <Dropzone files={currentInterpretation.files || []}
                              onChange={(files: any) => {
                                  console.log("qqqqq on change",);
                                  handleUpdateSubjects({files: [...files || []]})
                              }}
                              language={language}
                    ></Dropzone>
                </div>
                <Header>
                    <h3>Diseases</h3>
                    {isEditor && <MyModal title={'Connect to new Disease'}>
                        <InterpretationMainTable
                            connectIds={objectify(
                                (currentItem.data || {}).interpretationIds || []
                            )}
                            onConnect={(it: any, ind: number, status: boolean) => {
                                let _ids = (currentItem.data || {}).interpretationIds || []
                                if (status) {
                                    handleUpdateSubjects({
                                        interpretationIds: _.uniq([it._id, ..._ids]),
                                    })
                                } else {
                                    handleUpdateSubjects({
                                        interpretationIds: _ids.filter((item: any) => item != it._id),
                                    })
                                }
                            }}
                        ></InterpretationMainTable>

                    </MyModal>}
                </Header>

                <LinkedInterpretations
                    data={((currentItem.data || {}).interpretationIds || []).map(
                        (id: any) => interpretations[id]
                    )}
                    language={language}
                />
            </Body>

            {/* Add Language Modal */}
            <Dialog open={isAddLanguageModalOpen} onClose={() => setIsAddLanguageModalOpen(false)}>
                <DialogTitle>Add New Language</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Language Code"
                        value={selectedNewLanguage}
                        onChange={(e) => setSelectedNewLanguage(e.target.value)}
                        placeholder="e.g., fr, es, ru"
                        inputProps={{ maxLength: 2 }}
                        style={{ marginTop: 16 }}
                        helperText="Enter 2-letter language code (e.g., fr for French, es for Spanish)"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsAddLanguageModalOpen(false)}>Cancel</Button>
                    <Button
                        onClick={handleAddLanguage}
                        variant="contained"
                        disabled={
                            !selectedNewLanguage ||
                            selectedNewLanguage.length > 2 ||
                            availableLanguages.includes(selectedNewLanguage.toLowerCase())
                        }
                    >
                        Add Language
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}

export const objectify = (arr: any[]) => {
    console.log('qqqqq arrrrrrr', arr)
    return (arr || []).reduce((acc, it) => {
        return {...acc, [it]: true}
    }, {})
}

export default Recommendations
